import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-uxbuilder',
  templateUrl: './uxbuilder.component.html',
  styleUrls: ['./uxbuilder.component.scss']
})
export class UxbuilderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
